import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import styled from "styled-components";

export const PasswordWrapper = styled.div`
  position: relative;
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.circularIconBg};
    border-radius: 2px;
    color: ${({ theme }) => theme.circularIconTextBg};
  }
  color: ${({ theme }) => theme.text};
`;

const ToggleButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  border-radius: 50%;
  background: none;
  border: none;
`;

interface VisibilityProps {
  isDarkMode: boolean;
  passwordVisible: boolean;
  togglePasswordVisibility: () => void;
  isHoveredOrFocused: boolean;
}

const VisibilityIconComp: React.FC<VisibilityProps> = ({
  isDarkMode,
  passwordVisible,
  togglePasswordVisibility,
  isHoveredOrFocused,
}) => {
  const [btnFocusHover, setBtnFocusHover] = useState(false);

  //Handle focus and hover state of the button
  const handleBtnFocusHoverState = (state: boolean) => {
    setBtnFocusHover(state);
  };

  const iconColor = isHoveredOrFocused
    ? isDarkMode
      ? "#000"
      : "#fff"
    : "grey";

  const iconColorOnBtnFocus = isDarkMode ? "#000" : "#fff";

  return (
    <ToggleButton
      type="button"
      onClick={togglePasswordVisibility}
      onFocus={() => handleBtnFocusHoverState(true)}
      onBlur={() => handleBtnFocusHoverState(false)}
      onMouseEnter={() => handleBtnFocusHoverState(true)}
      onMouseLeave={() => handleBtnFocusHoverState(false)}
    >
      {passwordVisible ? (
        <VisibilityOffIcon
          style={{
            color: btnFocusHover ? iconColorOnBtnFocus : iconColor,
          }}
        />
      ) : (
        <VisibilityIcon
          style={{
            color: btnFocusHover ? iconColorOnBtnFocus : iconColor,
          }}
        />
      )}
    </ToggleButton>
  );
};

export default VisibilityIconComp;
